import {Series} from '@/types/api/competition'

export const getSeriesName = (series: Series) => `${series.order}. séria`
